export function generateUniqueId(): string {
    return `${window.location.pathname}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}
